import {IStoryblokImage} from "../../types/IStoryblokImage";
import {SbBlokData, StoryblokComponent, storyblokEditable} from "@storyblok/react";
import BlogHeader from "./BlogHeader";

type IProps = {
    story: any, // Not pretty
    blok: {
        author: string,
        body: any[],
        date: string,
        image: IStoryblokImage,
        intro: string,
        meta: any,
        title: string,
        _uid: string
    } & SbBlokData
}

import Breadrcumbs from "../internal/Breadcrumbs";
import React from "react";
import Head from "next/head";

export default function Blogpost(props: IProps) {
    const pages = [
        {name: 'Blog', href: '/blog', current: false},
        {name: props.blok.title, href: '#', current: true},
    ]

    const post = props.story;

    const dateString = post.content.date;
    // Get month name from Date String
    const date = new Date(dateString);
    const options = {month: 'long'};
    // @ts-ignore
    const monthName = new Intl.DateTimeFormat('en-US', options).format(date);

    return <>

        <BlogHeader blok={props.blok}/>


        <div className="blogpost bg-white padding-xs" {...storyblokEditable(props.blok)}>
            <div className="mx-auto max-w-4xl text-base text-gray-700  px-6 lg:px-8">
                {/*<div className={'pb-12'}>*/}
                {/*    <Breadrcumbs pages={pages}/>*/}

                {/*    <div className="pt-12 text-xs">*/}
                {/*        <time className="text-gray-500">*/}
                {/*            {monthName} {date.getFullYear()}*/}
                {/*        </time>*/}
                {/*        {post.tag_list.length > 0 &&*/}
                {/*            <span*/}
                {/*                className={"flex gap-2 mt-3"}*/}
                {/*            >*/}
                {/*        {post?.tag_list?.map((el: any, i: any) => {*/}
                {/*            return <span key={i}*/}
                {/*                         className={'bg-white text-primary border text-xs uppercase p-2 rounded-lg lg:text-gray-500 shadow'}*/}
                {/*            >{el}</span>*/}
                {/*        })}*/}
                {/*    </span>}*/}
                {/*    </div>*/}

                {/*</div>*/}

                <div className={'leading-loose '}>
                    {props.blok?.body?.map((nestedBlok: any) => (
                        <StoryblokComponent

                            blok={nestedBlok}
                            key={nestedBlok._uid}/>
                    ))}
                </div>
            </div>
        </div>

    </>
}